// src/utils/getSubdomain.ts
export const getSubdomain = (): string | null => {
  const hostname = window.location.hostname.toLowerCase().replace(/\.$/, '');
  const baseDomain = (process.env.REACT_APP_BASE_DOMAIN || '').toLowerCase();
  const defaultTenant = process.env.REACT_APP_DEFAULT_TENANT || null;

  if (baseDomain && hostname.endsWith(`.${baseDomain}`)) {
    const hostnamePrefix = hostname.slice(0, -(baseDomain.length + 1));
    return hostnamePrefix.split('.')[0] || defaultTenant;
  }

  return defaultTenant;
};
